/** Dev fallback when portal cookies are absent (see portalSession.ts). */
export const HARDCODED_CUSTOMER_ID = 'myhome';

export function getMainPortalBaseUrl(): string {
  return (import.meta.env.VITE_MAIN_PORTAL_BASEURL ?? '').trim();
}

export function joinMainPortalPath(path: string): string {
  const base = getMainPortalBaseUrl().replace(/\/+$/, '');
  if (!base) return '';
  const suffix = path.replace(/^\/+/, '');
  return `${base}/${suffix}`;
}

/** Main portal DPR issue / hindrance tracker (no query). Prefer openPortalUrl for navigation. */
export function getDprIssueTrackerUrl(): string {
  return joinMainPortalPath('requests/dprIssueTrackerProcess');
}

/**
 * Issues tracker filtered to one ticket.
 * Prefer `openPortalUrl('requests/dprIssueTrackerProcess', { query: { ticketId } })`
 * so shared cookies sync before navigation.
 */
export function getDprIssueTrackerTicketUrl(ticketId: string): string {
  const base = getDprIssueTrackerUrl();
  if (!base) return '';
  const id = String(ticketId ?? '').trim();
  if (!id) return base;

  try {
    const projectId =
      (typeof localStorage !== 'undefined'
        ? localStorage.getItem('gantt-planner:projectId')
        : null)?.trim() || '';
    const url = new URL(base);
    url.searchParams.set('ticketId', id);
    if (projectId) {
      url.searchParams.set('projectId', projectId);
    }
    return url.toString();
  } catch {
    return `${base}?ticketId=${encodeURIComponent(id)}`;
  }
}

const config = {
    environment: import.meta.env.VITE_ENV,
    TransactionServerUrl: import.meta.env.VITE_TRANSACTION_SERVER_URL,
    projectId: import.meta.env.VITE_PROJECT_ID,
    authToken: import.meta.env.VITE_AUTH_TOKEN,
    customerId: import.meta.env.VITE_CUSTOMER_ID || HARDCODED_CUSTOMER_ID,
}
export default config;
